import { Component, Input, OnInit } from '@angular/core';
import { ISimpleData } from '../../../../../../shared/models/simpleData.model';

@Component({
  selector: 'app-manage-airline-codes-dialog-list-item',
  templateUrl: './manage-airline-codes-dialog-list-item.component.html',
  styleUrls: ['./manage-airline-codes-dialog-list-item.component.scss']
})
export class ManageAirlineCodesDialogListItemComponent implements OnInit {

  @Input() item?: ISimpleData;
  @Input() opened?: boolean;
  @Input() shallNotOpen?: boolean;

  constructor() { }

  ngOnInit() {
  }

}
